import { render, staticRenderFns } from "./AutomatorBlockSingleRow.vue?vue&type=template&id=3c85ef44&scoped=true"
import script from "./AutomatorBlockSingleRow.vue?vue&type=script&lang=js"
export * from "./AutomatorBlockSingleRow.vue?vue&type=script&lang=js"
import style0 from "./AutomatorBlockSingleRow.vue?vue&type=style&index=0&id=3c85ef44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85ef44",
  null
  
)

export default component.exports